
const overlay = {
    namespaced: true,
    state: {
        visible: false
    },
    mutations: {
        LODING_OVERLAY: (state) => {
            state.visible = true;
        },
        ClOSE_OVERLAY: (state) => {
            state.visible = false;
        }
    },
    actions: {
        openOverlay(context) {
            context.commit('LODING_OVERLAY')
        },
        closeOverlay(context) {
            context.commit('ClOSE_OVERLAY')
        }
    }
}

export default overlay;